import { compose } from 'shared/utils/function.utils';
import { getStaticPagesSectionsReducer } from './get-static-page-sections';

export const extraReducers = compose(getStaticPagesSectionsReducer);

export { getStaticPagesSections } from './get-static-page-sections';
